module.exports = __webpack_public_path__ + "media/application/images/svgs/phone-8ce2620f2e334d0d5bfded686e8f70bc.svg";